import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { spacing } = lightTheme;

const styles: Record<string, SxProps> = {
  foxtonsTeam: {
    padding: {
      xs: spacing(0.5),
      md: spacing(0.5)
    },
    paddingLeft: {
      xs: 0,
      md: spacing(0.5)
    }
  }
};

export default styles;
